<template>
  <div>
    <el-dialog
      title="提示信息"
      :visible.sync="sendType"
      width="350px"
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <dd class="content">
        <span>您的{{ typeName }}次数已用完，如需更多请升级</span>
      </dd>
      <span slot="footer" class="dialog-footer">
        <el-button class="btnvip" @click="upgrade"
          >升级{{ getUserLevel(userLevel) }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ShowMessage",
  data() {
    return {
      sendType: this.showType
    };
  },
  props: {
    showType: {
      type: Boolean,
      default: false
    },
    typeName: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState("user", ["userLevel"])
  },
  methods: {
    upgrade() {
      this.sendType = false;
      let routeData = this.$router.resolve({ name: "permission" });
      window.open(routeData.href, "_blank");
    },
    handleClose() {
      this.sendType = false;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/mixin";
.boxMain {
  width: 350px;
}
/deep/.el-dialog__headerbtn {
  top: 15px;
}
/deep/.el-dialog__wrapper {
  top: 15%;
}
/deep/.el-dialog__header {
  padding: 10px 20px 10px;
  border-bottom: 1px solid @borderbottom;
}
/deep/.el-dialog__title {
  font-size: 16px;
}
/deep/.el-dialog__footer {
  text-align: center;
}
/deep/.el-dialog__body {
  margin-top: 10px;
  .content {
    text-align: center;
    font-size: 14px;
  }
}
.btnvip {
  .btn();
  padding: 10px 20px 10px 20px;
  border: 0;
}
</style>
